export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const navigateToSchools = () => {
    window.REACT_APP_NAVIGATE('/for-schools');
  };

  return (
    <footer className="bg-gradient-to-br from-rose-900 to-pink-900 text-white py-16 mx-6 mb-6 rounded-3xl">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12">
          <div>
            <h4 className="text-sm font-bold mb-4 text-white/80">メニュー</h4>
            <ul className="space-y-3">
              <li>
                <button
                  onClick={() => scrollToSection('why')}
                  className="text-sm hover:underline cursor-pointer text-white/90 hover:text-white transition-colors"
                >
                  エデュケーターとは
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('program')}
                  className="text-sm hover:underline cursor-pointer text-white/90 hover:text-white transition-colors"
                >
                  プログラム概要
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('certification')}
                  className="text-sm hover:underline cursor-pointer text-white/90 hover:text-white transition-colors"
                >
                  認定までの道のり
                </button>
              </li>
              <li>
                <button
                  onClick={() => scrollToSection('support')}
                  className="text-sm hover:underline cursor-pointer text-white/90 hover:text-white transition-colors"
                >
                  サポート体制
                </button>
              </li>
              <li>
                <button
                  onClick={navigateToSchools}
                  className="text-sm hover:underline cursor-pointer text-white/90 hover:text-white transition-colors"
                >
                  スクール・サロン向け
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold mb-4 text-white/80">お問い合わせ</h4>
            <ul className="space-y-3 text-sm text-white/90">
              <li>
                <i className="ri-phone-line mr-2"></i>
                03-5927-9061
              </li>
              <li>
                <i className="ri-mail-line mr-2"></i>
                info@nail-mius.co.jp
              </li>
            </ul>
            <h4 className="text-sm font-bold mt-6 mb-4 text-white/80">所在地</h4>
            <p className="text-sm text-white/90">
              〒170-0022<br />
              東京都豊島区南池袋3-16-8<br />
              The Kindai 6 Ikebururo 3階<br />
              株式会社マイアス 宛
            </p>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="flex space-x-6">
              <a 
                href="https://www.instagram.com/mirage.missmirage?igsh=ZHV2djlwb3hjYmRp" 
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors cursor-pointer text-white/80"
              >
                <i className="ri-instagram-line text-xl md:hidden"></i>
                <span className="hidden md:inline text-sm hover:underline">Instagram</span>
              </a>
              <a 
                href="https://nail-mius.co.jp/" 
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-white transition-colors cursor-pointer text-white/80"
              >
                <i className="ri-home-line text-xl md:hidden"></i>
                <span className="hidden md:inline text-sm hover:underline">ホームページ</span>
              </a>
              <a href="#" className="hover:text-white transition-colors cursor-pointer text-white/80">
                <i className="ri-line-line text-xl md:hidden"></i>
                <span className="hidden md:inline text-sm hover:underline">LINE</span>
              </a>
            </div>

            <p className="text-sm text-white/70">
              © 2025 Nail Educator Program. All rights reserved.
            </p>

            <div>
              <a 
                href="https://nail-mius.co.jp/policy.html" 
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm hover:underline cursor-pointer text-white/80 hover:text-white transition-colors"
              >
                プライバシーポリシー
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
